export const JOB = {
    POST: '/appearance/job',
    PUT: '/appearance/job',
    DELETE: '/appearance/job',
    CATEGORY: '/appearance/job/blog-category',
    BY_SLUG: '/appearance/job/blog-post-by-slug',
}
